<template>
  <div class="confirm">
    <div class="container">
      <Modal
        v-bind:responseType="responseType"
        v-bind:showModal="showModal"
        v-bind:response="response"
        v-bind:success="success"
        v-bind:failed="failed"
      />
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Modal from '../components/Modal.vue';

export default {
  components: { Modal },
  name: 'Confirm',
  data() {
    return {
      showModal:false,
      responseType:'',
      response:'',
      success:false,
      failed:false,
      valid:true,
      disabled:true,
    };
  },
  beforeMount(){
    this.showModal = true;
  },
  async beforeCreate(){

    try {
      const response = await axios.get(`/user/confirm?token=${this.$route.query.token}`);
      this.response = response.data.message;
      this.responseType = response.data.type;
      this.success = true;

    } catch (error) {
      this.response = error.response.data.message;
      this.responseType = error.response.data.type;
      this.failed = true;
    }
  },
  beforeUpdate(){
    if(this.success){
      // setInterval(()=>{
      // if(this.counter > 0)
      //   this.counter--

      // if(this.counter === 0)
      // this.$router.push('/login');
      // }, 1000)
    }
  },

};
</script>
<style scoped>
  .confirm {
    color: var(--white);
    display: flex;
    /* background: linear-gradient(to right, #297A91, #192851); */
    height: 100vh;
    background: var(--white);
  }

  @media only screen and (max-width:990px) {

  }
  @media only screen and (max-width:767px) {

  }
</style>
